import Main from './Main.vue'
import Automacoes from './components/Automacoes'

export default [{
  path: 'automacoes',
  name: 'automacoes',
  component: Main,
  children: [
    {path: '/', component: Automacoes, name: 'automacoes'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/automacoes/routes.js